import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useGroup } from '../context/GroupContext';
import AdminSidebar from './AdminSidebar';
import AIAssistantNew from './AIAssistantNew';
import StripeSetupBanner from './StripeSetupBanner';
import PlatformAdminGroupPicker from './modals/PlatformAdminGroupPicker';

const AdminLayout = ({ children }) => {
  const { currentUser } = useAuth();
  const { adminGroup, adminGroups, loading: groupLoading, isPlatformAdmin, selectGroup } = useGroup();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isAIAssistantOpen, setIsAIAssistantOpen] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const openAIAssistant = () => {
    setIsAIAssistantOpen(true);
  };

  const closeAIAssistant = () => {
    setIsAIAssistantOpen(false);
  };

  const handleActionExecuted = (result) => {
    console.log('Action executed:', result);
    // You can add any additional logic here, like refreshing data
  };

  // Only show admin layout for admin users
  if (currentUser?.role !== 'admin') {
    return children;
  }

  // Don't block the layout while loading - let the dashboard handle empty states
  // This allows the onboarding/empty state to show immediately for new groups

  return (
    <>
      {/* Platform admin group picker — shows when no group is selected yet */}
      {isPlatformAdmin && !adminGroup && adminGroups.length > 0 && (
        <PlatformAdminGroupPicker groups={adminGroups} onSelect={selectGroup} />
      )}

      <div className="flex h-screen bg-gray-50 overflow-hidden">
        <AdminSidebar 
          isCollapsed={isCollapsed} 
          onToggle={toggleSidebar}
          onOpenAI={openAIAssistant}
        />
        
        {/* Main Content */}
        <div className="flex-1 flex flex-col overflow-hidden">
          {/* Stripe Setup Banner - only appears within admin content area */}
          <StripeSetupBanner />
          
          {/* Content Area */}
          <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-50">
            <div className="mt-16 lg:mt-0 p-4">
              {children}
            </div>
          </main>
        </div>
      </div>
      
      {/* AI Assistant Modal - Outside of main layout to cover everything */}
      {isAIAssistantOpen && (
        <AIAssistantNew 
          isOpen={isAIAssistantOpen}
          onClose={closeAIAssistant} 
          groupLogo={adminGroup?.logo_url}
          groupId={adminGroup?.id}
          onActionExecuted={handleActionExecuted}
        />
      )}
    </>
  );
};

export default AdminLayout;
